import React from 'react';

import OfferIcon from '@/assets/icons/offer-icon.svg';
import EventIcon from '@/assets/icons/events.svg';

import ImageWrapper from '../../../../components/image-wrapper/Image-wrapper';
import { ILibraryTenantAttributeFilters } from '../../../../lib/fragments/libraryTenantAttributeFilters';
import { IMeetingPlacePageTenantEntertainmentItem } from '../../../../lib/fragments/meetingPlacePageTenantEntertainmentItem';
import { IMeetingPlacePageTenantFoodBevItem } from '../../../../lib/fragments/meetingPlacePageTenantFoodBevItem';
import { IMeetingPlacePageTenantShopItem } from '../../../../lib/fragments/meetingPlacePageTenantShopItem';
import { useTenantConfig } from '../../../../providers/ConfigProvider';

interface AttributeFilterIconsProps {
  page:
    | IMeetingPlacePageTenantShopItem
    | IMeetingPlacePageTenantEntertainmentItem
    | IMeetingPlacePageTenantFoodBevItem;
  attributeFilters?: ILibraryTenantAttributeFilters;
  cssClass?: string;
}

const AttributeFilterIcons = ({
  page,
  attributeFilters,
  cssClass = '',
}: AttributeFilterIconsProps) => {
  const config = useTenantConfig();
  const isLivliFamily = config?.NEXT_PUBLIC_IS_MP_LIVLI_FAMILY === 'true';
  const campaignNames = page?.offerCampaignNames;
  return (
    <div className={`flex flex-col gap-1 ${cssClass}`}>
      <div className="flex items-center">
        {page?.giftCard && attributeFilters?.giftCardIcon?.url && (
          <ImageWrapper
            url={attributeFilters.giftCardIcon.url}
            alt={attributeFilters?.giftCardIcon?.description ?? ''}
            imgClassName="mr-2 w-12"
            width={
              attributeFilters.giftCardIcon.width
                ? parseInt(attributeFilters.giftCardIcon.width)
                : undefined
            }
            height={
              attributeFilters.giftCardIcon.height
                ? parseInt(attributeFilters.giftCardIcon.height)
                : undefined
            }
          />
        )}
        {page?.loyaltyCard && attributeFilters?.loyaltyCardIcon?.url && (
          <ImageWrapper
            url={attributeFilters.loyaltyCardIcon.url}
            alt={attributeFilters?.loyaltyCardIcon?.description ?? ''}
            imgClassName="mr-2 w-12"
            width={
              attributeFilters.loyaltyCardIcon.width
                ? parseInt(attributeFilters.loyaltyCardIcon.width)
                : undefined
            }
            height={
              attributeFilters.loyaltyCardIcon.height
                ? parseInt(attributeFilters.loyaltyCardIcon.height)
                : undefined
            }
          />
        )}
        {page && page?.hasEvent && (
          <div className="w-12">
            <EventIcon />
          </div>
        )}
        {page?.hasOffer && (
          <div className="w-12">
            <OfferIcon
              viewBox="0 0 32 32"
              style={{ width: '2rem', height: '2rem' }}
            />
            {/* <OfferIcon className="w-full h-full" /> */}
          </div>
        )}
      </div>
      {/* {isLivliFamily && campaignNames?.some((t: string) => t.toLowerCase() === 'member day') && (
        <div className="flex flex-wrap gap-1 mt-6">
          <div
            style={{
              paddingLeft: 8,
              paddingRight: 8,
              paddingTop: 5,
              paddingBottom: 5,
              background: 'var(--Background-Neutral-medium, #F7F4EF)',
              borderRadius: 4,
              outline: '2px #FDC300 solid',
              outlineOffset: '-2px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
              display: 'inline-flex',
            }}
          >
            <div
              style={{
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
                color: 'var(--Text-Sticker-Neutral, #474747)',
                fontSize: 10,
                //  fontFamily: 'Noto IKEA Latin',
                fontWeight: '700',
                lineHeight: '15px',
                wordWrap: 'break-word',
              }}
            >
              Member Day
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default AttributeFilterIcons;
